// extracted by mini-css-extract-plugin
export default {"loading_container":"base-tab_loading_container__zfy7l","form_button":"base-tab_form_button__F12BF"};